export const SenderName = "KhouryCapital"
export const SenderEmailTo = "khoury.capital@khourycapital.ca"
export const SenderEmail = "khoury.capital@KhouryCapital.ca"
export const SenderEmailcustomer = "support@khourycapital.ca"
export const SenderEmailcustomerTo = "support@khourycapital.ca"
// export const CCEmail = "kimberly.eid@kozechalets.ca"
export const BrevoApiKey = "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"


